import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		weight: 2.5,
		uom: "kg"

	}
});

export default app;